import React from "react";

const ErrorHandlerContext = React.createContext(
  (title: string, error: any, action?: () => void) => {}
);

export default ErrorHandlerContext;
